export const saveDirtyMappingGroups = async ({
  groups,
  draft,
  orgId,
  save,
  reload,
  successType,
}) => {
  const writes = groups.map(group => save({
    org_uuid: orgId || undefined,
    vital_types: group.vitals,
    devices: draft[group.value] || [],
  }));
  const results = await Promise.allSettled(writes);
  await reload();

  const failed = results.find(result => (
    result.status === 'rejected' || result.value?.type !== successType
  ));
  if (!failed) {
    return null;
  }
  return failed.status === 'fulfilled' ? failed.value : failed.reason;
};
